// extracted by mini-css-extract-plugin
module.exports = {"chart":"device-bar_chart_33qj1"};